import { GET_INIT_DATA } from './action-types';
import { getRequestStatus } from '../requests/selectors';

export const isReady = (state) => state.init.ready;
export const [isFetching, hasError, errorData] = getRequestStatus(GET_INIT_DATA);
